<div kendoTooltip style="text-align: center;" [tooltipTemplate]="template">
  <fa-icon icon="{{icon}}" title="{{tooltip}}" [ngStyle]="{'color': color}" ></fa-icon>
</div>

<ng-template #template let-anchor>
  <div>{{ anchor | tooltip }}</div>
</ng-template>
